module.exports = __webpack_public_path__ + "img/z2.f23d4da0.png";